var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_3339_17115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 -0.0507812C10.7402 -0.0507812 -0.0507812 10.7372 -0.0507812 24.0002C-0.0507812 37.2632 10.7402 48.0512 24.0017 48.0512C37.2632 48.0512 48.0542 37.2632 48.0542 24.0002C48.0542 10.7372 37.2632 -0.0507812 24.0017 -0.0507812ZM24.0017 46.4492C11.6237 46.4492 1.55422 36.3782 1.55422 24.0002C1.55422 11.6222 11.6237 1.55122 24.0017 1.55122C36.3797 1.55122 46.4492 11.6222 46.4492 24.0002C46.4492 36.3782 36.3797 46.4492 24.0017 46.4492Z",
    fill: "#44AF69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 11.5H27.75C26.0924 11.5 24.5027 12.1585 23.3306 13.3306C22.1585 14.5027 21.5 16.0924 21.5 17.75V21.5H17.75V26.5H21.5V36.5H26.5V26.5H30.25L31.5 21.5H26.5V17.75C26.5 17.4185 26.6317 17.1005 26.8661 16.8661C27.1005 16.6317 27.4185 16.5 27.75 16.5H31.5V11.5Z",
    stroke: "#44AF69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3339_17115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.078d6f6415e52120ab210715182b14d9.svg";
export { ForwardRef as ReactComponent };